import styled from 'styled-components'

export const FieldsWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;

  > div {
    flex: 1;
  }
`

export const SourceWrapper = styled.div`
  margin-top: 16px;
  position: relative;

  > svg {
    right: -20px !important;
  }
`
